import {
    createStyles,
    Toolbar,
    WithStyles,
    withStyles,
} from "@material-ui/core";
import * as React from "react";

import { Button, RelodeTheme, Text } from "../";
import {
    SearchFacets,
    SearchFacetsProps,
    SearchResultsList,
    SearchResultsProps,
} from "./";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            display: "flex",
            flexDirection: "row",
            flexGrow: 1,
            padding: theme.spacing(0, 2),
        },
        criteria: {
            display: "flex",
            flexDirection: "column",
            flexGrow: 0,
            width: 250,
            marginRight: theme.spacing(4),
        },
        inputWrapper: {
            display: "flex",
            flexDirection: "column",
        },
        searchButton: {
            marginTop: theme.spacing(2),
        },
        results: {
            flexGrow: 1,
        },
    });

interface Props
    extends WithStyles<typeof styles>,
        SearchFacetsProps,
        SearchResultsProps {
    id?: string;
    children?: React.ReactNode;
    onSearch?: () => void;
    searchDisabled?: boolean;
    isBusy?: boolean;
    checkboxDisabled?: boolean;
}

export const SearchContainer = withStyles(styles, { name: "SearchContainer" })(
    (props: Props) => {
        const {
            actionComponent,
            actions,
            children,
            classes,
            criteria,
            data,
            facetConfig,
            facets,
            getColumns,
            hasResults,
            hideCheckbox,
            id,
            isBusy,
            noResultsText,
            onRequestSort,
            onSearch,
            onSelectedAction,
            refined,
            searchDisabled,
            selectedRows = [],
            sortDir,
            sortField,
            toolbarClassName,
            totalCount,
            onDeselectAll,
            onRowChecked,
            onRowUnchecked,
            onSelectAll,
            rowBody,
            entityName,
            checkboxDisabled,
        } = props;

        return (
            <div
                className={classes.root}
                id={`${id}-SearchContainer`}
                data-cy="searchContainer"
            >
                <div
                    className={classes.criteria}
                    id={`${id}-SearchCriteria`}
                    data-cy="searchCriteria"
                >
                    <div className={classes.inputWrapper}>
                        <Toolbar disableGutters={true}>
                            <Text variant="h2">criteria</Text>
                        </Toolbar>
                        {children}
                        {onSearch && (
                            <Button
                                data-cy="searchButton"
                                className={classes.searchButton}
                                fullWidth
                                id={`${id}SearchButton`}
                                onClick={onSearch}
                                size="small"
                                color="primary"
                                variant="contained"
                                disabled={searchDisabled}
                            >
                                search
                            </Button>
                        )}
                    </div>
                    <SearchFacets
                        id={`${id}-SearchFacets`}
                        criteria={criteria}
                        facets={facets}
                        facetConfig={facetConfig}
                        hasResults={hasResults}
                        refined={refined}
                    />
                </div>
                <div className={classes.results} id={`${id}-SearchResults`}>
                    <SearchResultsList
                        actionComponent={actionComponent}
                        actions={actions}
                        data={data}
                        getColumns={getColumns}
                        hideCheckbox={hideCheckbox}
                        noResultsText={noResultsText}
                        onRequestSort={onRequestSort}
                        onSelectedAction={onSelectedAction}
                        refined={refined}
                        sortDir={sortDir}
                        sortField={sortField}
                        toolbarClassName={toolbarClassName}
                        totalCount={totalCount}
                        selectedRows={selectedRows}
                        onDeselectAll={onDeselectAll}
                        onRowChecked={onRowChecked}
                        onRowUnchecked={onRowUnchecked}
                        onSelectAll={onSelectAll}
                        isBusy={isBusy}
                        rowBody={rowBody}
                        entityName={entityName}
                        checkboxDisabled={checkboxDisabled}
                    />
                </div>
            </div>
        );
    }
);

SearchContainer.displayName = "SearchContainer";
